import { render, staticRenderFns } from "./inputBox.vue?vue&type=template&id=448d8586&"
import script from "./inputBox.vue?vue&type=script&lang=js&"
export * from "./inputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports